module.exports = __webpack_public_path__ + "static/img/community10.6baa8a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community10.png
// module id = BNYY
// module chunks = 0